import { Loading } from '@monorepo/shared/componentsV2/Loading';
import React from 'react';
import styled from 'styled-components';
import { FileStatus, SubContainerTitle } from './styled';

const AiLoadingContainer = styled.div`
  display: grid;
  gap: 1rem;
  place-content: center;
  place-items: center;
  height: 100%;
`;

const StyledFileStatus = styled(FileStatus)`
  margin-bottom: 1rem;
`;

type LogEntriesLoadingOverlayProps = {
  isReadOnly: boolean;
};

export function LogEntriesLoadingOverlay({
  isReadOnly,
}: LogEntriesLoadingOverlayProps) {
  return (
    <AiLoadingContainer>
      {!isReadOnly && (
        <>
          <SubContainerTitle>
            Our AI is processing your files...
          </SubContainerTitle>
          <StyledFileStatus>
            This may take a few minutes. Please do not close this tab.
          </StyledFileStatus>
        </>
      )}
      <Loading />
    </AiLoadingContainer>
  );
}
